// DashboardLayout pages
import Overview from "./Overview.vue";
import Admins from "./Admins.vue";
import User from "./User.vue";
import Users from "./Users.vue";
import Admin from "./Admin.vue";
import Companies from "./Companies.vue";
import Company from "./Company.vue";
import Categories from "./Categories.vue";
import Category from "./Category.vue";
import Manuals from "./Manuals.vue";
import Manual from "./Manual.vue";
import Courses from "./Courses.vue";
import Course from "./Course.vue";
import Articles from "./Articles.vue";
import Article from "./Article.vue";
import Videos from "./Videos.vue";
import Video from "./Video.vue";
import Contacts from "./Contacts";
import Logs from "./Logs.vue";
import TestResults from "./TestResults.vue";
import TestResult from "./TestResult.vue";
import TestQuestion from "./TestQuestion.vue";
import Podcasts from "./Podcasts.vue";
import Podcast from "./Podcast.vue";
import Specialist from "./Specialist.vue";
import Specialists from "./Specialists.vue";
import Chats from "./Chats.vue";
import Chat from "./Chat.vue";
import Lgpd from "./Lgpd.vue";
import Srq20Email from "./Srq20Email.vue"
import CompanyArticle from "./CompanyArticle.vue"
import CompaniesDepartments from "./CompaniesDepartments.vue";
import CompanyDepartment from "./CompanyDepartment.vue";
import CompaniesBranches from "./CompaniesBranches.vue";
import CompanyBranch from "./CompanyBranch.vue";

export default {
  Overview,
  Admin,
  Admins,
  User,
  Users,
  Companies,
  Company,
  Categories,
  Category,
  Manuals,
  Manual,
  Courses,
  Course,
  Articles,
  Article,
  Videos,
  Video,
  Contacts,
  Logs,
  TestResults,
  TestResult,
  TestQuestion,
  Podcasts,
  Podcast,
  Specialist,
  Specialists,
  Chats,
  Chat,
  Lgpd,
  Srq20Email,
  CompanyArticle,
  CompaniesDepartments,
  CompanyDepartment,
  CompaniesBranches,
  CompanyBranch
};
